import {useState} from "react";
import {useLocation, useNavigate} from "react-router";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {DropdownAction, DropdownActionItem} from "@/components/quickActionsBar/DropdownAction.tsx";
import {QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {Incident, IncidentType} from "@/lib/types/statuspages.ts";
import {deleteIncident} from "@/pages/statuspages/utils/quickActions.ts";

export interface IncidentUpdateRowActionsProps {
  incident: Incident;
  statusPageID: number;
}

export const IncidentUpdateRowActions = ({statusPageID, incident}: IncidentUpdateRowActionsProps) => {
  const [showDelete, setShowDelete] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleIncidentEditClick = () => {
    const params = new URLSearchParams();
    params.set("redirectTo", location.pathname + location.search);

    navigate(`/incidents/${incident.id}/edit?${params.toString()}`);
  };

  const formType = incident.incident_type === IncidentType.INCIDENT ? "Incident" : "Scheduled Maintenance";
  return (
    <>
      <DeleteActionDialog
        show={showDelete}
        title={`Delete ${formType}`}
        onCancel={() => setShowDelete(false)}
        onConfirm={async () => {
          await deleteIncident(statusPageID, incident.id);
          setShowDelete(false);
        }}
      >
        Are you sure you want to delete <code>{incident.name}</code> ?
      </DeleteActionDialog>
      <QuickActionsBar
        id={`incident-action-${incident.id}`}
        actions={[
          <DropdownAction
            id={`incident-dd-${incident.id}`}
            items={[
              <DropdownActionItem text="Edit" onClick={() => handleIncidentEditClick()} />,
              <DropdownActionItem text="Delete" onClick={() => setShowDelete(true)} />,
            ]}
          />,
        ]}
      />
    </>
  );
};
